import React from 'react';
import styles from './styles.module.scss';
import gridStyles from 'src/shared/theme/grid.module.scss';
import MarketingSection from 'src/components/MarketingSection';
import classnames from 'classnames';
import { useTranslation, Trans } from 'next-i18next';
import Point from './components/Point';

interface Props {
    selectedPoint: string;
}

const PointsSection = (props: Props) => {
    const { t } = useTranslation();

    const points = [
        {
            number: '01',
            title: t('offerings_point1_title'),
            sections: [
                {
                    title: t('offerings_point1_section1_title'),
                    description: <Trans i18nKey="offerings_point1_section1_description" />,
                },
            ],
        },
        {
            number: '02',
            title: t('offerings_point2_title'),
            sections: [
                {
                    title: t('offerings_point2_section1_title'),
                    description: <Trans i18nKey="offerings_point2_section1_description" />,
                },
                {
                    title: t('offerings_point2_section2_title'),
                    description: <Trans i18nKey="offerings_point2_section2_description" />,
                },
            ],
        },

        {
            number: '03',
            title: t('offerings_point3_title'),
            sections: [
                {
                    title: t('offerings_point3_section1_title'),
                    description: <Trans i18nKey="offerings_point3_section1_description" />,
                },
            ],
        },
        {
            number: '04',
            title: t('offerings_point4_title'),
            sections: [
                {
                    description: <Trans i18nKey="offerings_point4_section1_description" />,
                },
            ],
        },
    ];

    const pointClassnames = classnames(gridStyles.xl3, gridStyles.lg6);

    return (
        <MarketingSection containerClassName={styles.pointsSection} className={styles.inner}>
            <div className={gridStyles.container}>
                {points.map((x, i) => (
                    <div key={x.number} className={pointClassnames}>
                        <Point {...x} isDisabled={props.selectedPoint && x.number !== props.selectedPoint} isLast={i === points.length - 1} />
                    </div>
                ))}
            </div>
            <div className={styles.line} />
        </MarketingSection>
    );
};

export default PointsSection;
